import React from "react";
import "./StudentActivityMonthlyAttendance.scss";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

const StudentActivityMonthlyAttendance = ({ activityData }) => {
  const attendance = {
    attended:
      activityData?.allActivityDetails?.class_attendance?.calculated || 0,
    total: activityData?.allActivityDetails?.class_attendance?.total || 1,
  };

  const hostelHours = {
    used: activityData?.allActivityDetails?.hostel_hours?.calculated || 0,
    total: activityData?.allActivityDetails?.hostel_hours?.total || 1,
  };

  const meals = [
    {
      label: "Breakfast",
      value: activityData?.allActivityDetails?.breakfast?.calculated || 0,
      total: activityData?.allActivityDetails?.breakfast?.total || 1,
      color: "#F4A261",
    },
    {
      label: "Lunch",
      value: activityData?.allActivityDetails?.lunch?.calculated || 0,
      total: activityData?.allActivityDetails?.lunch?.total || 1,
      color: "#6BAED6",
    },
    {
      label: "Dinner",
      value: activityData?.allActivityDetails?.dinner?.calculated || 0,
      total: activityData?.allActivityDetails?.dinner?.total || 1,
      color: "#F4D35E",
    },
  ];

  return (
    <div className="dashboard-container">
      <div className="progress-container">
        <div className="progress-card">
          <p>Classes Attended</p>
          <p className="last-child">
            <strong>
              {attendance.attended}/{attendance.total}
            </strong>{" "}
            classes
          </p>
          <div className="progress-bar">
            <div
              className="progress-fill"
              style={{
                width: `${(attendance.attended / attendance.total) * 100}%`,
                backgroundColor: "rgba(21, 164, 52, 1)",
              }}
            ></div>
          </div>
        </div>

        <div className="progress-card">
          <p>Hostel Hours</p>
          <p className="last-child">
            <strong>{hostelHours.used}</strong> hrs /{" "}
            <strong>{hostelHours.total}</strong> hrs
          </p>
          <div className="progress-bar">
            <div
              className="progress-fill"
              style={{
                width: `${(hostelHours.used / hostelHours.total) * 100}%`,
                backgroundColor: "rgba(21, 140, 164, 1)",
              }}
            ></div>
          </div>
        </div>
      </div>

      <div className="circular-progress-container">
        {meals.map((meal, index) => (
          <div className="circular-progress-card" key={index}>
            <p>{meal.label}</p>
            <CircularProgressbar
              value={(meal.value / meal.total) * 100}
              text={`${meal.value} /${meal.total}`}
              styles={buildStyles({
                pathColor: meal.color,
                textColor: "#000",
                trailColor: "#EAEAEA",
                textSize: "16px",
              })}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default StudentActivityMonthlyAttendance;
